import {
  addBusinessDistrictApi,
  setBusinessDistrictCbdStateApi,
  updateBusinessDistrictApi,
  queryBusinessDistrictApi,
  getBusinessDistrictListApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加商圈信息
  async addBusinessDistrictAction(context, param) {
    const res = await addBusinessDistrictApi(param)
    return res
  },
  //  设置商圈状态信息
  async setBusinessDistrictCbdStateAction(context, param) {
    const res = await setBusinessDistrictCbdStateApi(param)
    return res
  },
  //  修改商圈信息
  async updateBusinessDistrictAction(context, param) {
    const res = await updateBusinessDistrictApi(param)
    return res
  },
  //  查询商圈列表信息
  async queryBusinessDistrictAction(context, param) {
    const res = await queryBusinessDistrictApi(param)
    return res
  },
  //  获取商圈列表信息
  async getBusinessDistrictListAction(context, param) {
    const res = await getBusinessDistrictListApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
